import { render, staticRenderFns } from "./PaymentSwiftTopUpCancelDuplicateModal.vue?vue&type=template&id=723b06ba"
import script from "./PaymentSwiftTopUpCancelDuplicateModal.vue?vue&type=script&lang=js"
export * from "./PaymentSwiftTopUpCancelDuplicateModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentSwiftTopUpCancelDuplicateModal.vue?vue&type=style&index=0&id=723b06ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports